module.exports = __webpack_public_path__ + "img/河边露营.c7dce288.png";